 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {createBlockMarkdownSpec} from '@tiptap/core'
import {mergeAttributes, Node} from '@tiptap/react'
import ms from 'ms'

export const InsightsBlockBase = Node.create({
  name: 'insightsBlock',

  isolating: true,

  defining: true,

  group: 'block',

  content: 'block*',

  inline: false,

  addAttributes() {
    return {
      id: {
        default: () => crypto.randomUUID(),
        parseHTML: (element) => element.getAttribute('data-id'),
        renderHTML: (attributes) => ({
          'data-id': attributes.id
        })
      },

      editing: {
        default: true,
        parseHTML: (element) => {
          return element.getAttribute('data-editing') === '' ? true : false
        },
        renderHTML: (attributes) => {
          return {
            'data-editing': attributes.editing ? '' : undefined
          }
        }
      },
      teamIds: {
        default: [],
        parseHTML: (element) => {
          return _nullishCoalesce(_optionalChain([element, 'access', _ => _.getAttribute, 'call', _2 => _2('data-team-ids'), 'optionalAccess', _3 => _3.split, 'call', _4 => _4(',')]), () => ( []))
        },
        renderHTML: ({teamIds}) => ({
          'data-team-ids': teamIds.length ? teamIds.join(',') : undefined
        })
      },
      meetingTypes: {
        default: ['retrospective'],
        parseHTML: (element) => _nullishCoalesce(_optionalChain([element, 'access', _5 => _5.getAttribute, 'call', _6 => _6('data-meeting-types'), 'optionalAccess', _7 => _7.split, 'call', _8 => _8(',')]), () => ( [])),
        renderHTML: ({meetingTypes}) => ({
          'data-meeting-types': meetingTypes.length ? meetingTypes.join(',') : undefined
        })
      },
      after: {
        default: () => new Date(Date.now() - ms('12w')).toISOString(),
        parseHTML: (element) =>
          new Date(element.getAttribute('data-after') ).toISOString(),
        renderHTML: (attributes) => ({
          'data-after': attributes.after
        })
      },
      before: {
        default: () => new Date().toISOString(),
        parseHTML: (element) =>
          new Date(element.getAttribute('data-before') ).toISOString(),
        renderHTML: (attributes) => ({
          'data-before': attributes.before
        })
      },
      meetingIds: {
        default: [],
        parseHTML: (element) => _nullishCoalesce(_optionalChain([element, 'access', _9 => _9.getAttribute, 'call', _10 => _10('data-meeting-ids'), 'optionalAccess', _11 => _11.split, 'call', _12 => _12(',')]), () => ( [])),
        renderHTML: ({meetingIds}) => ({
          'data-meeting-ids': meetingIds.length ? meetingIds.join(',') : undefined
        })
      },
      title: {
        default: 'Latest Team Insights',
        parseHTML: (element) => element.getAttribute('data-title'),
        renderHTML: (attributes) => ({
          'data-title': attributes.title
        })
      },
      hash: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-hash'),
        renderHTML: (attributes) => ({
          'data-hash': attributes.hash
        })
      },
      prompt: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-prompt'),
        renderHTML: (attributes) => ({
          'data-prompt': attributes.prompt
        })
      },
      error: {
        parseHTML: (element) => element.getAttribute('data-error'),
        renderHTML: (attributes) => ({
          'data-error': attributes.error
        })
      }
    }
  },
  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`
      }
    ]
  },

  renderHTML({HTMLAttributes}) {
    return ['div', mergeAttributes(HTMLAttributes, {'data-type': this.name}), 0]
  },

  ...createBlockMarkdownSpec({
    nodeName: 'insightsBlock',
    allowedAttributes: ['teamIds', 'meetingTypes', 'after', 'before', 'meetingIds', 'title']
  })
})
